import React from "react";
import PrimaryButton from "../../components/PrimaryButton";
import { Card, Col, Form, Row } from "react-bootstrap";
import SelectDropdown from "../../components/SelectDropdown";
import CloseIcon from "@mui/icons-material/Close";
import useEditMappingViewController from "../../viewControllers/MappinManagementControllers/EditMappingViewController";
import Loader from "../../components/Loader";
import i18n from "../../constants/Strings";

const EditMapping = () => {

  const {
    goBack,
    values,
    touched,
    errors,
    setFieldValue,
    handleSubmit,
    gwpList,
    mappingData,
    editState,
    setEditState,
    loading
  } = useEditMappingViewController();

  const text = {
    pageHeading: i18n.t('mappingManagement.editMapping.pageHeading'),
    backBtn: i18n.t('mappingManagement.editMapping.backBtn'),
    updateBtn: i18n.t('mappingManagement.editMapping.updateBtn'),
    goodStockHSID: i18n.t('mappingManagement.editMapping.goodStockHSID'),
    gwpHSID: i18n.t('mappingManagement.editMapping.gwpHSID'),
    goodStockItemName: i18n.t('mappingManagement.editMapping.goodStockItemName'),
    gwpItemName: i18n.t('mappingManagement.editMapping.gwpItemName'),
    goodStockWatsonID: i18n.t('mappingManagement.editMapping.goodStockWatsonID'),
    gwpWatsonID: i18n.t('mappingManagement.editMapping.gwpWatsonID'),
    gwpSKU: i18n.t('mappingManagement.editMapping.gwpSKU'),
    clickToUpdate: i18n.t('mappingManagement.editMapping.clickToUpdate'),
  }

  return (
    <>
      {loading ? <Loader /> : (
        <div className="container-fluid mt-5">
          <div className="mb-4">
            <div className="card-header py-3">
              <h6 className="back-btn" onClick={goBack}>{"< Back"}</h6>
              <h6 className="m-0 font-weight-bold txt-primary">
                {text.pageHeading}
              </h6>
            </div>

            <Card style={{ width: "100%", height: "500px" }}>
              <Form className="mt-4 mb-4 px-4" onSubmit={handleSubmit}>
                <Row className="px-5">
                  <Col className="col-lg-6">
                    <h5>
                      {text.goodStockHSID}
                      <span className="fs-sm">
                        {mappingData?.good_item_hs_id ?? "-"}
                      </span>{" "}
                    </h5>
                  </Col>
                  <Col className="col-lg-6">
                    <h5>
                      {text.gwpHSID}
                      <span className="fs-sm">
                        {mappingData?.gwp_item_hs_id ?? "-"}
                      </span>{" "}
                    </h5>
                  </Col>
                </Row>

                <Row className="px-5 mt-4">
                  <Col className="col-lg-6">
                    <h5>
                      {text.goodStockItemName}
                      <span>{mappingData?.good_item_name ?? "-"}</span>{" "}
                    </h5>
                  </Col>

                  <Col className="col-lg-6">
                    <h5>
                      {text.gwpItemName}
                      <span>{mappingData?.gwp_item_name ?? "-"}</span>{" "}
                    </h5>
                  </Col>
                </Row>
                <Row className="px-5 mt-4">
                  <Col className="col-lg-6">
                    <h5>
                      {text.goodStockWatsonID}
                      <span>{mappingData?.good_item_id ?? "-"}</span>{" "}
                    </h5>
                  </Col>

                  <Col className="col-lg-6">
                    <h5>
                      {text.gwpWatsonID}
                      <span>{mappingData?.gwp_item_id ?? "-"}</span>{" "}
                    </h5>
                  </Col>
                </Row>

                <Row className=" mt-4">
                  <Col className=" col-lg-6">
                    <Row>
                      <Col className="col-lg-3 mt-3">
                        <p>{text.gwpSKU}</p>
                      </Col>
                      <Col className=" col-lg-9">
                        <SelectDropdown
                          isDisabled={editState}
                          isSearchable={true}
                          placeholder="Search by SKU-ID or Name"
                          data={gwpList}
                          value={values?.gwp_sku_item?.item_sid}
                          onChange={(e) => {
                            setFieldValue("gwp_sku_item", e?.value);
                          }}
                          errors={
                            touched?.gwp_sku_item?.item_sid &&
                            errors?.gwp_sku_item?.item_sid
                          }
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col className="col-lg-3">
                    {editState === false ? (
                      <div
                        className="mt-2 cursor-pointer px-1"
                        onClick={() => setEditState(true)}
                      >
                        <CloseIcon fontSize="large" />
                      </div>
                    ) : (
                      <div
                        className="mt-2 cursor-pointer px-1"
                        onClick={() => setEditState(false)}
                      >
                        <PrimaryButton
                          text={text.clickToUpdate}
                          className="width-auto h-0 create-btn"
                        />
                      </div>
                    )}
                  </Col>
                </Row>
                {editState ? null : (
                  <PrimaryButton
                    type="submit"
                    text={text.updateBtn}
                    className="width-auto save-btn "
                  />
                )}
              </Form>
            </Card>
          </div>
        </div>
      )}
    </>
  );
};

export default EditMapping;
